var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "free-products insicht insicht--fade-up" },
    [
      _vm.loaded && !_vm.showSuccess && !_vm.notFound
        ? [
            _vm.introTitle
              ? _c("h2", {
                  staticClass: "free-products__title text-block__title",
                  domProps: { innerHTML: _vm._s(_vm.introTitle) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.introText
              ? _c("div", {
                  staticClass: "free-products__text text-block__text",
                  domProps: { innerHTML: _vm._s(_vm.introText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoggedIn
              ? [
                  _c("div", { staticClass: "free-products__user" }, [
                    _c("span", {
                      staticClass: "free-products__user-greeting",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("freeproducts.userGreeting"))
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "sanitize",
                          rawName: "v-sanitize",
                          value: _vm.userFullName,
                          expression: "userFullName"
                        }
                      ],
                      staticClass: "free-products__user-name"
                    })
                  ])
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "free-products__login" },
                    [
                      _c("span", {
                        staticClass: "free-products__login-hint",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("freeproducts.userLoginHint")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          level: "primary",
                          text: _vm.$t("freeproducts.userLoginButton"),
                          type: "button",
                          small: ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openLogin.apply(null, arguments)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
            _vm._v(" "),
            _vm.promotionsEnhanced.length
              ? [
                  _vm.response.message
                    ? _c("GeneralMessage", {
                        ref: "message",
                        attrs: {
                          message: _vm.response.message,
                          type: _vm.response.type
                        },
                        on: {
                          close: function($event) {
                            _vm.response.message = ""
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "free-products__subtitle",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("freeproducts.productsTitle"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "free-products__promotions" },
                    _vm._l(_vm.promotionsEnhanced, function(promotion) {
                      return _c(
                        "li",
                        {
                          key: promotion.code,
                          staticClass: "free-products__promotion",
                          class: {
                            "free-products__promotion--multi":
                              promotion.products.length > 1,
                            "free-products__promotion--gone":
                              promotion.left <= 0
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "free-products__promotion-products",
                              class: {
                                "free-products__promotion-products--multi":
                                  promotion.products.length > 1
                              }
                            },
                            _vm._l(promotion.products, function(product) {
                              return _c(
                                "div",
                                {
                                  key: product.code,
                                  staticClass:
                                    "free-products__promotion-product"
                                },
                                [
                                  _vm.productLabel(product)
                                    ? _c("img", {
                                        staticClass: "products__item-label",
                                        attrs: {
                                          src: _vm.productLabel(product),
                                          loading: "lazy"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "free-products__promotion-product-image"
                                    },
                                    [
                                      _c(
                                        "figure",
                                        {
                                          staticClass:
                                            "products__item-image-wrapper"
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "products__item-image-element",
                                            attrs: {
                                              src: product.image,
                                              alt: product.name,
                                              loading: "lazy"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("h4", {
                                    staticClass:
                                      "free-products__promotion-product-name",
                                    class: {
                                      "free-products__promotion-product-name--no-variant": !product
                                        .variant.name
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(product.name)
                                    }
                                  }),
                                  _vm._v(" "),
                                  product.variant.name
                                    ? _c("h5", {
                                        staticClass:
                                          "free-products__promotion-product-variant",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            product.variant.name
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  product.description
                                    ? _c("div", {
                                        staticClass:
                                          "free-products__promotion-product-description",
                                        domProps: {
                                          innerHTML: _vm._s(product.description)
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "free-products__promotion-available",
                            class: {
                              "free-products__promotion-available--multi":
                                promotion.products.length > 1
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("freeproducts.productsAvailable", {
                                  count: Math.max(promotion.left, 0)
                                })
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("FormInputCheckbox", {
                            staticClass: "free-products__promotion-checkbox",
                            attrs: {
                              value: promotion.code,
                              checked:
                                _vm.selectedPromotionCode === promotion.code,
                              disabled: promotion.left <= 0
                            },
                            on: {
                              input: function($event) {
                                return _vm.setPromotion(promotion, $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("Button", {
                    attrs: {
                      level: "primary",
                      text: _vm.$t("freeproducts.sendButton"),
                      type: "button",
                      disabled: _vm.loading || !_vm.selectedPromotionCode
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onSubmit.apply(null, arguments)
                      }
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm.loaded && !_vm.notFound
        ? [
            _c("h2", {
              staticClass: "free-products__title text-block__title",
              domProps: {
                innerHTML: _vm._s(_vm.$t("freeproducts.success.title"))
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "free-products__text text-block__text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("freeproducts.success.text"))
              }
            }),
            _vm._v(" "),
            _c("h2", {
              staticClass: "free-products__subtitle",
              domProps: {
                innerHTML: _vm._s(_vm.$t("freeproducts.success.productTitle"))
              }
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "free-products__promotions" }, [
              _c(
                "li",
                {
                  staticClass: "free-products__promotion",
                  class: {
                    "free-products__promotion--multi":
                      _vm.selectedPromotion.products.length > 1
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "free-products__promotion-products",
                      class: {
                        "free-products__promotion-products--multi":
                          _vm.selectedPromotion.products.length > 1
                      }
                    },
                    _vm._l(_vm.selectedPromotion.products, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.code,
                          staticClass: "free-products__promotion-product"
                        },
                        [
                          _vm.productLabel(product)
                            ? _c("img", {
                                staticClass: "products__item-label",
                                attrs: {
                                  src: _vm.productLabel(product),
                                  loading: "lazy"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "free-products__promotion-product-image"
                            },
                            [
                              _c(
                                "figure",
                                { staticClass: "products__item-image-wrapper" },
                                [
                                  _c("img", {
                                    staticClass: "products__item-image-element",
                                    attrs: {
                                      src: product.image,
                                      alt: product.name,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", {
                            staticClass:
                              "free-products__promotion-product-name",
                            class: {
                              "free-products__promotion-product-name--no-variant": !product
                                .variant.name
                            },
                            domProps: { innerHTML: _vm._s(product.name) }
                          }),
                          _vm._v(" "),
                          product.variant.name
                            ? _c("h5", {
                                staticClass:
                                  "free-products__promotion-product-variant",
                                domProps: {
                                  innerHTML: _vm._s(product.variant.name)
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          product.description
                            ? _c("div", {
                                staticClass:
                                  "free-products__promotion-product-description",
                                domProps: {
                                  innerHTML: _vm._s(product.description)
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                level: "primary",
                text: _vm.$t("freeproducts.success.homeButton"),
                type: "button"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onHome.apply(null, arguments)
                }
              }
            })
          ]
        : [
            _c("h2", {
              staticClass: "free-products__title text-block__title",
              domProps: {
                innerHTML: _vm._s(_vm.$t("freeproducts.notfound.title"))
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "free-products__text text-block__text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("freeproducts.notfound.text"))
              }
            }),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                level: "primary",
                text: _vm.$t("freeproducts.success.homeButton"),
                type: "button"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onHome.apply(null, arguments)
                }
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }